export function localDateStr(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function todayStr(): string {
  return localDateStr(new Date());
}

export function shiftDate(dateStr: string, days: number): string {
  const d = new Date(dateStr + "T12:00:00");
  d.setDate(d.getDate() + days);
  return localDateStr(d);
}

export function toMinutes(dateStr: string): number {
  const h = parseInt(dateStr.slice(11, 13), 10);
  const m = parseInt(dateStr.slice(14, 16), 10);
  return h * 60 + m;
}

export function formatTime(dateStr: string): string {
  return dateStr.slice(11, 16);
}

export function formatDateFi(dateStr: string): string {
  const d = new Date(dateStr + "T12:00:00");
  return d.toLocaleDateString("fi-FI", {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
}
